import { MANAGEMENT_PERMISSIONS_SERVER } from '@shared/constants/permissions';
import { WorkspaceMemberPermission } from '@shared/components/ManageUsersModalTable/types';

export const CANNOT_CHANGE_MY_ROLE_IN_WS_TOOLTIP =
  "You can't update your own role";
export const CANNOT_CHANGE_ORG_ADMIN_ROLE_IN_WS_TOOLTIP =
  "You can't change the role, since this user is an organization admin";

export const WORKSPACE_MEMBER_PERMISSIONS: WorkspaceMemberPermission[] = [
  {
    key: MANAGEMENT_PERMISSIONS_SERVER.INVITE_USERS,
    label: 'Invite Users (IU)',
    text: 'Invite users to workspace'
  },
  {
    key: MANAGEMENT_PERMISSIONS_SERVER.PROJECT_VISIBILITY,
    label: 'Project Settings (PS)',
    text: 'Change project settings and visibility'
  },
  {
    key: MANAGEMENT_PERMISSIONS_SERVER.MODEL_REGISTRY,
    label: 'Model Registry (MR)',
    text: 'Change model registry permission'
  }
];
